export default __webpack_public_path__ + "static/media/ceiling-recessed.edee11b5.svg";